unit uMenu;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, WEBLib.CDS, WEBLib.REST,
  Vcl.Controls, Vcl.Grids, WEBLib.DBCtrls, WEBLib.JSON,
  WEBLib.StdCtrls, System.Variants, Variants,
  WEBLib.ExtCtrls, Vcl.Imaging.jpeg,
  WEBLib.ComCtrls, WEBLib.Buttons, Vcl.StdCtrls, Vcl.Graphics,
  Vcl.Imaging.pngimage, System.DateUtils, Vcl.Menus, WEBLib.Menus;

type
  TFMenu = class(TForm)
    WebPanel1: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    WebPanel2: TPanel;
    WebImageControl1: TImageControl;
    WebMemo1: TMemo;
    WebSpeedButton5: TSpeedButton;
    WebSpeedButton6: TSpeedButton;
    WebSpeedButton7: TSpeedButton;
    WebPanel3: TPanel;
    WebImageControl2: TImageControl;
    WebEdit1: TEdit;
    WebEdit2: TEdit;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebButton1: TButton;
    TUsuarios: TClientDataSet;
    CUsuarios: TClientConnection;
    DsUsuarios: TDataSource;
    WebSpeedButton8: TSpeedButton;
    WebSpeedButton9: TSpeedButton;
    WebPanel4: TPanel;
    WebSpeedButton10: TSpeedButton;
    WebLabel3: TLabel;
    WebEdit3: TEdit;
    WebLabel4: TLabel;
    WebImageControl3: TImageControl;
    WebMemo2: TMemo;
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure CUsuariosAfterConnect(Sender: TObject);
    procedure WebSpeedButton9Click(Sender: TObject);
    procedure WebSpeedButton8Click(Sender: TObject);
    procedure WebSpeedButton10Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  FMenu: TFMenu;
  MNivel: String;

implementation

uses uCerrarSolicitud, uDocAsigna, uDocEntrena, uDocGenAsigna, uRegEntEmp,
  uSolicitudDwk, uUsuarios, uArchivoDWK, uMenuReportes;


{$R *.dfm}

function Base64Encode(const S: string): string;
begin
  asm
    // btoa espera Latin1; para texto "normal" funciona perfecto
    Result = btoa(S);
  end;
end;

function Base64Decode(const S: string): string;
begin
  asm
    Result = atob(S);
  end;
end;

procedure TFMenu.CUsuariosAfterConnect(Sender: TObject);
begin
if (TUsuarios.FieldByName('User').AsString = WebEdit1.Text) and
   (TUsuarios.FieldByName('Pass').AsString = WebEdit2.Text) then
   begin
   WebPanel3.Visible:=False;
   WebPanel1.Visible:=True;
   WebPanel4.Visible:=True;
   WebEdit3.Text:=TUsuarios.FieldByName('Numero').AsString;
   WebMemo2.Text:=TUsuarios.FieldByName('Nombre').AsString;
   MNivel:=TUsuarios.FieldByName('Nivel').AsString;
   //INICIO DE SESION
   end
else
 begin
 ShowMessage('Error. Usuario no registrado!!!');
 end;
WebButton1.Enabled:=True;
end;

procedure TFMenu.WebButton1Click(Sender: TObject);
begin
CUsuarios.Command := httpGET;
  CUsuarios.URI := 'http://207.244.241.82:9000/Usuarios?User=' + WebEdit1.Text +
    '&Pass=' + Base64Encode(WebEdit2.Text);
CUsuarios.Active := True;
WebButton1.Enabled:=False;
end;

procedure TFMenu.WebFormCreate(Sender: TObject);
begin
WebPanel3.Height:=857;
WebPanel3.Width:=378;
WebPanel3.Align :=alLeft;
WebPanel1.Visible:=False;
WebPanel4.Visible:=False;

  asm
    var p = document.getElementById("webimagecontrol3");
    if (p) {
    p.style.borderRadius = "50%";

    p.style.boxShadow = "0 8px 25px rgba(0,0,0,0.25)";
     }
  end;
end;

procedure TFMenu.WebSpeedButton10Click(Sender: TObject);
begin
  asm
    window.location.reload();
  end;
end;

procedure TFMenu.WebSpeedButton1Click(Sender: TObject);
begin
  if (TUsuarios.FieldByName('Nivel').AsString = '2') or
    (TUsuarios.FieldByName('Nivel').AsString = '3') or
    (TUsuarios.FieldByName('Nivel').AsString = '4') then
  begin
    // ESTO ES PARA GUARDAR LA FORMA COMO HISTORAL Y QUE PUEDA USAR LA NAVEGACION DE LAS FLECHAS
    asm
      history.pushState({ page: "FMenu" }, "FMenu", "#FMenu");
    end;

    TFDocEntrena.CreateNew(
      procedure(AForm: TObject)
      begin
        FDocEntrena := TFDocEntrena(AForm);
        FDocEntrena.Show;
      end);
  end
else ShowMessage('No es posible acceder con el usuario actual!!');
end;

procedure TFMenu.WebSpeedButton2Click(Sender: TObject);
begin
  if (TUsuarios.FieldByName('Nivel').AsString = '4') then
  begin
    // ESTO ES PARA GUARDAR LA FORMA COMO HISTORAL Y QUE PUEDA USAR LA NAVEGACION DE LAS FLECHAS
    asm
      history.pushState({ page: "FMenu" }, "FMenu", "#FMenu");
    end;

    TFRegEntEmp.CreateNew(
      procedure(AForm: TObject)
      begin
        FRegEntEmp := TFRegEntEmp(AForm);
        FRegEntEmp.Show;
      end);
  end
else ShowMessage('No es posible acceder con el usuario actual!!');
end;

procedure TFMenu.WebSpeedButton3Click(Sender: TObject);
begin
  if (TUsuarios.FieldByName('Nivel').AsString = '2') or
    (TUsuarios.FieldByName('Nivel').AsString = '3') or
    (TUsuarios.FieldByName('Nivel').AsString = '4') then
  begin
    // ESTO ES PARA GUARDAR LA FORMA COMO HISTORAL Y QUE PUEDA USAR LA NAVEGACION DE LAS FLECHAS
    asm
      history.pushState({ page: "FMenu" }, "FMenu", "#FMenu");
    end;

    TFDocAsigna.CreateNew(
      procedure(AForm: TObject)
      begin
        FDocAsigna := TFDocAsigna(AForm);
        FDocAsigna.Show;
      end);
  end
else ShowMessage('No es posible acceder con el usuario actual!!');
end;

procedure TFMenu.WebSpeedButton4Click(Sender: TObject);
begin
  if (TUsuarios.FieldByName('Nivel').AsString = '4') then
  begin
    // ESTO ES PARA GUARDAR LA FORMA COMO HISTORAL Y QUE PUEDA USAR LA NAVEGACION DE LAS FLECHAS
    asm
      history.pushState({ page: "FMenu" }, "FMenu", "#FMenu");
    end;

    TFDocGenAsigna.CreateNew(
      procedure(AForm: TObject)
      begin
        FDocGenAsigna := TFDocGenAsigna(AForm);
        FDocGenAsigna.Show;
      end);
  end
else ShowMessage('No es posible acceder con el usuario actual!!');
end;

procedure TFMenu.WebSpeedButton5Click(Sender: TObject);
begin
  if (TUsuarios.FieldByName('Nivel').AsString = '3') or
    (TUsuarios.FieldByName('Nivel').AsString = '4') then
  begin
    asm
      history.pushState({ page: "FMenu" }, "FMenu", "#FMenu");
    end;

    TFMenuReportes.CreateNew(
      procedure(AForm: TObject)
      begin
        FMenuReportes := TFMenuReportes(AForm);
        FMenuReportes.Show;
      end);
  end
else ShowMessage('No es posible acceder con el usuario actual!!');

end;

procedure TFMenu.WebSpeedButton6Click(Sender: TObject);
begin
  if (TUsuarios.FieldByName('Nivel').AsString = '1') or
    (TUsuarios.FieldByName('Nivel').AsString = '2') or
    (TUsuarios.FieldByName('Nivel').AsString = '3') or
    (TUsuarios.FieldByName('Nivel').AsString = '4') then
  begin
    // ESTO ES PARA GUARDAR LA FORMA COMO HISTORAL Y QUE PUEDA USAR LA NAVEGACION DE LAS FLECHAS
    asm
      history.pushState({ page: "FMenu" }, "FMenu", "#FMenu");
    end;

    TFSolicitudDwk.CreateNew(
      procedure(AForm: TObject)
      begin
        FSolicitudDwk := TFSolicitudDwk(AForm);
        uSolicitudDwk.MDocumento := '';
        uSolicitudDwk.MAgrega := '';
        FSolicitudDwk.Show;
      end);
  end
else ShowMessage('No es posible acceder con el usuario actual!!');
end;

procedure TFMenu.WebSpeedButton7Click(Sender: TObject);
begin
  if (TUsuarios.FieldByName('Nivel').AsString = '4') then
  begin
    // ESTO ES PARA GUARDAR LA FORMA COMO HISTORAL Y QUE PUEDA USAR LA NAVEGACION DE LAS FLECHAS
    asm
      history.pushState({ page: "FMenu" }, "FMenu", "#FMenu");
    end;

    TFCerrarSolicitud.CreateNew(
      procedure(AForm: TObject)
      begin
        FCerrarSolicitud := TFCerrarSolicitud(AForm);
        FCerrarSolicitud.Show;
      end);
  end
else ShowMessage('No es posible acceder con el usuario actual!!');
end;

procedure TFMenu.WebSpeedButton8Click(Sender: TObject);
begin
  if (TUsuarios.FieldByName('Nivel').AsString = '4') then
  begin
    // ESTO ES PARA GUARDAR LA FORMA COMO HISTORAL Y QUE PUEDA USAR LA NAVEGACION DE LAS FLECHAS
    asm
      history.pushState({ page: "FMenu" }, "FMenu", "#FMenu");
    end;

    TFArchivoDWK.CreateNew(
      procedure(AForm: TObject)
      begin
        FArchivoDWK := TFArchivoDWK(AForm);
        FArchivoDWK.Show;
      end);
  end
else ShowMessage('No es posible acceder con el usuario actual!!');
end;

procedure TFMenu.WebSpeedButton9Click(Sender: TObject);
begin
  if (TUsuarios.FieldByName('Nivel').AsString = '4') then
  begin
    // ESTO ES PARA GUARDAR LA FORMA COMO HISTORAL Y QUE PUEDA USAR LA NAVEGACION DE LAS FLECHAS
    asm
      history.pushState({ page: "FMenu" }, "FMenu", "#FMenu");
    end;

    TFUsuarios.CreateNew(
      procedure(AForm: TObject)
      begin
        FUsuarios := TFUsuarios(AForm);
        FUsuarios.Show;
      end);
  end
else ShowMessage('No es posible acceder con el usuario actual!!');
end;

procedure TFMenu.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  WebSpeedButton9 := TSpeedButton.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebImageControl1 := TImageControl.Create(Self);
  WebMemo1 := TMemo.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebImageControl2 := TImageControl.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebImageControl3 := TImageControl.Create('webimagecontrol3');
  WebSpeedButton10 := TSpeedButton.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebMemo2 := TMemo.Create(Self);
  TUsuarios := TClientDataSet.Create(Self);
  CUsuarios := TClientConnection.Create(Self);
  DsUsuarios := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  WebSpeedButton9.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebImageControl1.BeforeLoadDFMValues;
  WebMemo1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebImageControl2.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebImageControl3.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebMemo2.BeforeLoadDFMValues;
  TUsuarios.BeforeLoadDFMValues;
  CUsuarios.BeforeLoadDFMValues;
  DsUsuarios.BeforeLoadDFMValues;
  try
    Name := 'FMenu';
    Width := 1714;
    Height := 1022;
    Caption := 'Menu - Entrenamientos - PROGINTEL';
    Color := clBtnFace;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1097;
    WebPanel1.Height := 1022;
    WebPanel1.HeightPercent := 100.000000000000000000;
    WebPanel1.WidthPercent := 100.000000000000000000;
    WebPanel1.Align := alLeft;
    WebPanel1.BorderColor := clBlack;
    WebPanel1.BorderStyle := bsSingle;
    WebPanel1.ChildOrder := 5;
    WebPanel1.Color := 4855714;
    WebPanel1.Visible := False;
    WebSpeedButton1.SetParentComponent(WebPanel1);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 32;
    WebSpeedButton1.Top := 36;
    WebSpeedButton1.Width := 337;
    WebSpeedButton1.Height := 185;
    WebSpeedButton1.Cursor := crHandPoint;
    WebSpeedButton1.Caption := 'Documentos de entrenamiento';
    WebSpeedButton1.Color := clBtnFace;
    WebSpeedButton1.Font.Charset := DEFAULT_CHARSET;
    WebSpeedButton1.Font.Color := clWindowText;
    WebSpeedButton1.Font.Height := -15;
    WebSpeedButton1.Font.Name := 'Tahoma';
    WebSpeedButton1.Font.Style := [];
    WebSpeedButton1.Glyph.LoadFromFile('uMenu.WebPanel1.WebSpeedButton1.Glyph.png');
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.Layout := blGlyphTop;
    WebSpeedButton1.ParentFont := False;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(WebPanel1);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 32;
    WebSpeedButton2.Top := 235;
    WebSpeedButton2.Width := 337;
    WebSpeedButton2.Height := 185;
    WebSpeedButton2.Cursor := crHandPoint;
    WebSpeedButton2.Caption := 'Registra entrenamiento a empleados';
    WebSpeedButton2.Color := clBtnFace;
    WebSpeedButton2.Font.Charset := DEFAULT_CHARSET;
    WebSpeedButton2.Font.Color := clWindowText;
    WebSpeedButton2.Font.Height := -15;
    WebSpeedButton2.Font.Name := 'Tahoma';
    WebSpeedButton2.Font.Style := [];
    WebSpeedButton2.Glyph.LoadFromFile('uMenu.WebPanel1.WebSpeedButton2.Glyph.png');
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.Layout := blGlyphTop;
    WebSpeedButton2.ParentFont := False;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(WebPanel1);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 32;
    WebSpeedButton3.Top := 434;
    WebSpeedButton3.Width := 337;
    WebSpeedButton3.Height := 185;
    WebSpeedButton3.Cursor := crHandPoint;
    WebSpeedButton3.Caption := 'Asignar entrenamientos a los puestos';
    WebSpeedButton3.Color := clBtnFace;
    WebSpeedButton3.Font.Charset := DEFAULT_CHARSET;
    WebSpeedButton3.Font.Color := clWindowText;
    WebSpeedButton3.Font.Height := -15;
    WebSpeedButton3.Font.Name := 'Tahoma';
    WebSpeedButton3.Font.Style := [];
    WebSpeedButton3.Glyph.LoadFromFile('uMenu.WebPanel1.WebSpeedButton3.Glyph.png');
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.Layout := blGlyphTop;
    WebSpeedButton3.ParentFont := False;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebSpeedButton4.SetParentComponent(WebPanel1);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 32;
    WebSpeedButton4.Top := 638;
    WebSpeedButton4.Width := 337;
    WebSpeedButton4.Height := 185;
    WebSpeedButton4.Cursor := crHandPoint;
    WebSpeedButton4.Caption := 'Asignar documentos gen'#233'ricos a los puestos';
    WebSpeedButton4.Color := clBtnFace;
    WebSpeedButton4.Font.Charset := DEFAULT_CHARSET;
    WebSpeedButton4.Font.Color := clWindowText;
    WebSpeedButton4.Font.Height := -15;
    WebSpeedButton4.Font.Name := 'Tahoma';
    WebSpeedButton4.Font.Style := [];
    WebSpeedButton4.Glyph.LoadFromFile('uMenu.WebPanel1.WebSpeedButton4.Glyph.png');
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.Layout := blGlyphTop;
    WebSpeedButton4.ParentFont := False;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    WebSpeedButton5.SetParentComponent(WebPanel1);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 384;
    WebSpeedButton5.Top := 36;
    WebSpeedButton5.Width := 337;
    WebSpeedButton5.Height := 185;
    WebSpeedButton5.Cursor := crHandPoint;
    WebSpeedButton5.Caption := 'Impresi'#243'n de reportes';
    WebSpeedButton5.Color := clBtnFace;
    WebSpeedButton5.Font.Charset := DEFAULT_CHARSET;
    WebSpeedButton5.Font.Color := clWindowText;
    WebSpeedButton5.Font.Height := -15;
    WebSpeedButton5.Font.Name := 'Tahoma';
    WebSpeedButton5.Font.Style := [];
    WebSpeedButton5.Glyph.LoadFromFile('uMenu.WebPanel1.WebSpeedButton5.Glyph.png');
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.Layout := blGlyphTop;
    WebSpeedButton5.ParentFont := False;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    WebSpeedButton6.SetParentComponent(WebPanel1);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 384;
    WebSpeedButton6.Top := 235;
    WebSpeedButton6.Width := 337;
    WebSpeedButton6.Height := 185;
    WebSpeedButton6.Cursor := crHandPoint;
    WebSpeedButton6.Caption := 'Generar DWK - 013';
    WebSpeedButton6.Color := clBtnFace;
    WebSpeedButton6.Font.Charset := DEFAULT_CHARSET;
    WebSpeedButton6.Font.Color := clWindowText;
    WebSpeedButton6.Font.Height := -15;
    WebSpeedButton6.Font.Name := 'Tahoma';
    WebSpeedButton6.Font.Style := [];
    WebSpeedButton6.Glyph.LoadFromFile('uMenu.WebPanel1.WebSpeedButton6.Glyph.png');
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.Layout := blGlyphTop;
    WebSpeedButton6.ParentFont := False;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    WebSpeedButton7.SetParentComponent(WebPanel1);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 384;
    WebSpeedButton7.Top := 434;
    WebSpeedButton7.Width := 337;
    WebSpeedButton7.Height := 185;
    WebSpeedButton7.Cursor := crHandPoint;
    WebSpeedButton7.Caption := 'Finalizar DWK - 013';
    WebSpeedButton7.Color := clBtnFace;
    WebSpeedButton7.Font.Charset := DEFAULT_CHARSET;
    WebSpeedButton7.Font.Color := clWindowText;
    WebSpeedButton7.Font.Height := -15;
    WebSpeedButton7.Font.Name := 'Tahoma';
    WebSpeedButton7.Font.Style := [];
    WebSpeedButton7.Glyph.LoadFromFile('uMenu.WebPanel1.WebSpeedButton7.Glyph.png');
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.Layout := blGlyphTop;
    WebSpeedButton7.ParentFont := False;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton7, Self, 'OnClick', 'WebSpeedButton7Click');
    WebSpeedButton8.SetParentComponent(WebPanel1);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 384;
    WebSpeedButton8.Top := 638;
    WebSpeedButton8.Width := 337;
    WebSpeedButton8.Height := 185;
    WebSpeedButton8.Cursor := crHandPoint;
    WebSpeedButton8.Caption := 'Archivo DWK';
    WebSpeedButton8.Color := clBtnFace;
    WebSpeedButton8.Font.Charset := DEFAULT_CHARSET;
    WebSpeedButton8.Font.Color := clWindowText;
    WebSpeedButton8.Font.Height := -15;
    WebSpeedButton8.Font.Name := 'Tahoma';
    WebSpeedButton8.Font.Style := [];
    WebSpeedButton8.Glyph.LoadFromFile('uMenu.WebPanel1.WebSpeedButton8.Glyph.png');
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.Layout := blGlyphTop;
    WebSpeedButton8.ParentFont := False;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton8, Self, 'OnClick', 'WebSpeedButton8Click');
    WebSpeedButton9.SetParentComponent(WebPanel1);
    WebSpeedButton9.Name := 'WebSpeedButton9';
    WebSpeedButton9.Left := 736;
    WebSpeedButton9.Top := 36;
    WebSpeedButton9.Width := 337;
    WebSpeedButton9.Height := 185;
    WebSpeedButton9.Cursor := crHandPoint;
    WebSpeedButton9.Caption := 'Usuarios';
    WebSpeedButton9.Color := clBtnFace;
    WebSpeedButton9.Font.Charset := DEFAULT_CHARSET;
    WebSpeedButton9.Font.Color := clWindowText;
    WebSpeedButton9.Font.Height := -15;
    WebSpeedButton9.Font.Name := 'Tahoma';
    WebSpeedButton9.Font.Style := [];
    WebSpeedButton9.Glyph.LoadFromFile('uMenu.WebPanel1.WebSpeedButton9.Glyph.png');
    WebSpeedButton9.HeightPercent := 100.000000000000000000;
    WebSpeedButton9.Layout := blGlyphTop;
    WebSpeedButton9.ParentFont := False;
    WebSpeedButton9.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton9, Self, 'OnClick', 'WebSpeedButton9Click');
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 1119;
    WebPanel2.Top := 16;
    WebPanel2.Width := 322;
    WebPanel2.Height := 369;
    WebPanel2.HeightPercent := 100.000000000000000000;
    WebPanel2.WidthPercent := 100.000000000000000000;
    WebPanel2.BorderColor := clBlack;
    WebPanel2.BorderStyle := bsSingle;
    WebPanel2.Caption := 'WebPanel2';
    WebPanel2.ChildOrder := 3;
    WebPanel2.Color := clWhite;
    WebImageControl1.SetParentComponent(WebPanel2);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 11;
    WebImageControl1.Top := 3;
    WebImageControl1.Width := 300;
    WebImageControl1.Height := 300;
    WebImageControl1.HeightPercent := 100.000000000000000000;
    WebImageControl1.WidthPercent := 100.000000000000000000;
    WebImageControl1.ChildOrder := 4;
    WebImageControl1.Picture.LoadFromFile('uMenu.WebPanel2.WebImageControl1.Picture.png');
    WebMemo1.SetParentComponent(WebPanel2);
    WebMemo1.Name := 'WebMemo1';
    WebMemo1.Left := 11;
    WebMemo1.Top := 309;
    WebMemo1.Width := 300;
    WebMemo1.Height := 52;
    WebMemo1.AutoSize := False;
    WebMemo1.Font.Charset := DEFAULT_CHARSET;
    WebMemo1.Font.Color := clWindowText;
    WebMemo1.Font.Height := -12;
    WebMemo1.Font.Name := 'Tahoma';
    WebMemo1.Font.Style := [];
    WebMemo1.HeightPercent := 100.000000000000000000;
    WebMemo1.Lines.BeginUpdate;
    try
      WebMemo1.Lines.Clear;
      WebMemo1.Lines.Add('Software desarrollado por ProgIntel');
      WebMemo1.Lines.Add(#169' 2025 ProgIntel '#8211' Todos los derechos reservados');
      WebMemo1.Lines.Add('Versi'#243'n 2.0');
    finally
      WebMemo1.Lines.EndUpdate;
    end;
    WebMemo1.ParentFont := False;
    WebMemo1.ReadOnly := True;
    WebMemo1.SelLength := 0;
    WebMemo1.SelStart := 100;
    WebMemo1.WidthPercent := 100.000000000000000000;
    WebPanel3.SetParentComponent(Self);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 1455;
    WebPanel3.Top := 411;
    WebPanel3.Width := 349;
    WebPanel3.Height := 434;
    WebPanel3.HeightPercent := 100.000000000000000000;
    WebPanel3.WidthPercent := 100.000000000000000000;
    WebPanel3.BorderColor := clSilver;
    WebPanel3.BorderStyle := bsSingle;
    WebPanel3.ChildOrder := 2;
    WebPanel3.Color := 4855714;
    WebImageControl2.SetParentComponent(WebPanel3);
    WebImageControl2.Name := 'WebImageControl2';
    WebImageControl2.Left := 112;
    WebImageControl2.Top := 56;
    WebImageControl2.Width := 128;
    WebImageControl2.Height := 128;
    WebImageControl2.HeightPercent := 100.000000000000000000;
    WebImageControl2.WidthPercent := 100.000000000000000000;
    WebImageControl2.AutoSize := True;
    WebImageControl2.Picture.LoadFromFile('uMenu.WebPanel3.WebImageControl2.Picture.png');
    WebLabel1.SetParentComponent(WebPanel3);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 88;
    WebLabel1.Top := 208;
    WebLabel1.Width := 40;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Usuario:';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWhite;
    WebLabel1.Font.Height := -11;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel3);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 88;
    WebLabel2.Top := 255;
    WebLabel2.Width := 60;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Contrase'#241'a:';
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWhite;
    WebLabel2.Font.Height := -11;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebEdit1.SetParentComponent(WebPanel3);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 88;
    WebEdit1.Top := 227;
    WebEdit1.Width := 169;
    WebEdit1.Height := 22;
    WebEdit1.ChildOrder := 1;
    WebEdit1.HeightPercent := 100.000000000000000000;
    WebEdit1.WidthPercent := 100.000000000000000000;
    WebEdit2.SetParentComponent(WebPanel3);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 88;
    WebEdit2.Top := 274;
    WebEdit2.Width := 169;
    WebEdit2.Height := 22;
    WebEdit2.ChildOrder := 1;
    WebEdit2.HeightPercent := 100.000000000000000000;
    WebEdit2.PasswordChar := '*';
    WebEdit2.WidthPercent := 100.000000000000000000;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 128;
    WebButton1.Top := 328;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Iniciar sesi'#243'n';
    WebButton1.ChildOrder := 5;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebPanel4.SetParentComponent(Self);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 1119;
    WebPanel4.Top := 411;
    WebPanel4.Width := 322;
    WebPanel4.Height := 434;
    WebPanel4.HeightPercent := 100.000000000000000000;
    WebPanel4.WidthPercent := 100.000000000000000000;
    WebPanel4.BorderColor := clSilver;
    WebPanel4.BorderStyle := bsSingle;
    WebPanel4.ChildOrder := 2;
    WebPanel4.Color := 4855714;
    WebLabel3.SetParentComponent(WebPanel4);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 80;
    WebLabel3.Top := 176;
    WebLabel3.Width := 41;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'N'#250'mero:';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWhite;
    WebLabel3.Font.Height := -11;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel4);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 80;
    WebLabel4.Top := 223;
    WebLabel4.Width := 41;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Nombre:';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWhite;
    WebLabel4.Font.Height := -11;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [];
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebImageControl3.SetParentComponent(WebPanel4);
    WebImageControl3.Name := 'WebImageControl3';
    WebImageControl3.Left := 101;
    WebImageControl3.Top := 40;
    WebImageControl3.Width := 121;
    WebImageControl3.Height := 121;
    WebImageControl3.HeightPercent := 100.000000000000000000;
    WebImageControl3.WidthPercent := 100.000000000000000000;
    WebImageControl3.ChildOrder := 7;
    WebImageControl3.Picture.LoadFromFile('uMenu.WebPanel4.WebImageControl3.Picture.png');
    WebSpeedButton10.SetParentComponent(WebPanel4);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 80;
    WebSpeedButton10.Top := 347;
    WebSpeedButton10.Width := 169;
    WebSpeedButton10.Height := 48;
    WebSpeedButton10.Caption := 'Cerrar sesi'#243'n';
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.Glyph.LoadFromFile('uMenu.WebPanel4.WebSpeedButton10.Glyph.png');
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton10, Self, 'OnClick', 'WebSpeedButton10Click');
    WebEdit3.SetParentComponent(WebPanel4);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 80;
    WebEdit3.Top := 195;
    WebEdit3.Width := 169;
    WebEdit3.Height := 22;
    WebEdit3.ChildOrder := 1;
    WebEdit3.HeightPercent := 100.000000000000000000;
    WebEdit3.ReadOnly := True;
    WebEdit3.WidthPercent := 100.000000000000000000;
    WebMemo2.SetParentComponent(WebPanel4);
    WebMemo2.Name := 'WebMemo2';
    WebMemo2.Left := 80;
    WebMemo2.Top := 242;
    WebMemo2.Width := 169;
    WebMemo2.Height := 79;
    WebMemo2.AutoSize := False;
    WebMemo2.Font.Charset := DEFAULT_CHARSET;
    WebMemo2.Font.Color := clWindowText;
    WebMemo2.Font.Height := -11;
    WebMemo2.Font.Name := 'Tahoma';
    WebMemo2.Font.Style := [];
    WebMemo2.HeightPercent := 100.000000000000000000;
    WebMemo2.Lines.BeginUpdate;
    try
      WebMemo2.Lines.Clear;
      WebMemo2.Lines.Add('WebMemo2');
    finally
      WebMemo2.Lines.EndUpdate;
    end;
    WebMemo2.ParentFont := False;
    WebMemo2.ReadOnly := True;
    WebMemo2.SelLength := 0;
    WebMemo2.SelStart := 0;
    WebMemo2.WidthPercent := 100.000000000000000000;
    TUsuarios.SetParentComponent(Self);
    TUsuarios.Name := 'TUsuarios';
    TUsuarios.Connection := CUsuarios;
    TUsuarios.Left := 864;
    TUsuarios.Top := 392;
    CUsuarios.SetParentComponent(Self);
    CUsuarios.Name := 'CUsuarios';
    CUsuarios.Active := False;
    CUsuarios.AfterConnect := CUsuariosAfterConnect;
    CUsuarios.Left := 792;
    CUsuarios.Top := 392;
    DsUsuarios.SetParentComponent(Self);
    DsUsuarios.Name := 'DsUsuarios';
    DsUsuarios.DataSet := TUsuarios;
    DsUsuarios.Left := 936;
    DsUsuarios.Top := 392;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    WebSpeedButton9.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebImageControl1.AfterLoadDFMValues;
    WebMemo1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebImageControl2.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebImageControl3.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebMemo2.AfterLoadDFMValues;
    TUsuarios.AfterLoadDFMValues;
    CUsuarios.AfterLoadDFMValues;
    DsUsuarios.AfterLoadDFMValues;
  end;
end;

end.
